import type { RootState } from './reducer';
import { appListeners } from './modules/app/listeners';
import { createListenerMiddleware } from '@myua/rtk-helper';

export const { startListening, listenerMiddleware, takeOnce, takeEvery, takeLatestById } =
  createListenerMiddleware<RootState>();

appListeners();
